import React, { useState,useEffect } from 'react';
import "../styles/Front_Header.css";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const year = new Date().getFullYear();
  return (
     <footer className="hc-footer section-padding">
    <div className="container">
      <div className="row">
        <div className="grid-5 hc-footer-grid">
            <div className="footer-col">
              <div>
                <h3>Shop by Category</h3>
              </div>
              <ul>
                <li><a href="#category/health">Health</a></li>
                <li><a href="#category/womens-intimacy">Women's Intimacy </a></li>
                <li><a href="#category/hair-care">Hair Care</a></li>
                {/* <li><a href="#category/health">Health</a></li> */}
                <li><a href="#/ayush-product-list">Medicine</a></li>
              </ul>
             </div>
             <div className="footer-col">
              <div>
              <h3>Quick Links</h3>
          </div>
          <ul>
            <li><a href="#treatments/">Treatment</a></li>
            <li><a href="#doctor-list-page">Doctor's List</a></li>
            <li><a href="#clinic-list-page">Find Clinic</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <div>
              <h3>Company</h3>
          </div>
          <ul>
            <li><a href="#about">About Us</a></li>
            <li><a href="#faq">FAQs</a></li>
            <li><a href="#privicy-policy">Privacy Policy</a></li>
            <li><a href="#cancellation-policy">Cancellation Policy</a></li>
            <li><a href="#shipping-policy">Shipping Policy</a></li>
            <li><a href="#terms-condition">Terms & Conditions</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </div>
         <div className="footer-col">
           <div>
              <h3>Get in Touch</h3>
          </div>
            <ul className="contact-items">

      <li className="item">
        <i className="fa-solid fa-location-dot"></i>
        {/* <span>Dr.Shreevarma's Wellness
            Padmalayam,1st Floor,
            3/233 A (SF NO 34/25 ) Manapakkam Main Road Manapakkam 
            Chennai-600125</span> */}
            <span>
              Dr. Shreevarma's Wellness, Padmalayam, 1st Floor, 3/233-A (SF No. 34/25), Manapakkam Main Road, Manapakkam, Chennai-600125.
            </span>
      </li>

      <li className="item">
        <i className="fa-regular fa-envelope"></i>
        <a href="mailto:mainadmin@shreevarma.org">mainadmin@shreevarma.org</a>
      </li>

      <li className="item">
        <i className="fa-solid fa-phone"></i>
        <a href="tel:+919500946631"> 9500946631</a> |  <a href="tel:+919500946631">9500946632</a>
      </li>

    </ul>

    <div className="social-icons">
      <a href="#" aria-label="YouTube"><i className="fa-brands fa-youtube"></i></a>
      <a href="#" aria-label="Facebook"><i className="fa-brands fa-facebook-f"></i></a>
      <a href="#" aria-label="Instagram"><i className="fa-brands fa-instagram"></i></a>
      <a href="#" aria-label="LinkedIn"><i className="fa-brands fa-linkedin-in"></i></a>
    </div>
        </div>

        <div className="footer-col hc-footer-app">
          <div>
              <h3>Download Our App</h3>
          </div>
          <p className="hc-footer-app-text">Book consultations, order medicines &amp; track your health — all from your phone.</p>
          <div className="hc-footer-app-badges">
            <a href="#" className="hc-footer-app-badge" onClick={(e) => e.preventDefault()} aria-label="Get it on Google Play">
              <i className="fa-brands fa-google-play"></i>
              <span><small>Get it on</small>Google Play</span>
            </a>
            <a href="#" className="hc-footer-app-badge" onClick={(e) => e.preventDefault()} aria-label="Download on the App Store">
              <i className="fa-brands fa-apple"></i>
              <span><small>Download on the</small>App Store</span>
            </a>
          </div>
        </div>

        </div>
      </div>

      <div className="hc-footer-bottom">
        <p>© {year} Dr.Shreevarma's Wellness. All rights reserved.</p>
        <button type="button" className="hc-footer-totop" onClick={scrollToTop} aria-label="Back to top">
          <i className="fa-solid fa-arrow-up"></i>
        </button>
      </div>
    </div>
</footer>
  );
};

export default Footer;